import React from 'react'
import styled from 'styled-components'

import { Fonts, Icon } from 'components/base-ui'
import media from 'styles/media'

import { useTranslation } from 'react-i18next'

interface TakeAwayLineItemsContainerProps {
  children?: React.ReactNode
  className?: string
}

const { screenXsMax } = media

const TakeAwayLineItemsContainer = ({ children, ...rest }: TakeAwayLineItemsContainerProps) => {
  const { t } = useTranslation()

  return (
    <PrivateCartItemListTakeAwayWrapper {...rest}>
      <PrivateCartItemListHeader>
        <Icon name="house-2" size="12px" />
        <Fonts.SmallTitleBold>{t('dineIn.services.takeAway')}</Fonts.SmallTitleBold>
      </PrivateCartItemListHeader>
      {children}
    </PrivateCartItemListTakeAwayWrapper>
  )
}

export default TakeAwayLineItemsContainer

const PrivateCartItemListTakeAwayWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  row-gap: 15px;
  padding: 12px 8px;
  margin-left: -8px;
  margin-right: -8px;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background-color: ${({ theme }) => theme.colors.primary};
    border-radius: 8px;
    z-index: -1;
    opacity: 0.08;
  }

  @media (${screenXsMax}) {
    row-gap: 10px;
  }
`

const PrivateCartItemListHeader = styled.div`
  position: relative;
  color: ${({ theme }) => theme.colors.primary};
  display: flex;
  align-items: center;
  padding-bottom: 10px;

  &::after {
    content: '';
    position: absolute;
    right: 0;
    bottom: -1px;
    left: 0;
    height: 1px;
    background-color: ${({ theme }) => theme.colors.baseGrey};
    opacity: 0.5;
  }

  i {
    margin-right: 7px;
    position: relative;
    top: -1px;
  }
`
